// For typescript exhaustiveness checks
export function assertNever(message: string, value: never) {
  throw new Error(`[ASSERT_NEVER] Assert never with message: ${message} and value: ${JSON.stringify(value)}`);
}

// For code paths that should never be reached
export function assertUnreachable(message: string, value: unknown) {
  throw new Error(
    `[ASSERT_UNREACHABLE] Assert unreachable with message: ${message} and value: ${JSON.stringify(value)}`,
  );
}
